import "./cartproducts.css"
import { useGlobalContext } from "../../context";   
import { FaX } from "react-icons/fa6";
import CurrencyFormat from "react-currency-format"
import DetailPrice from "../detailPrice/detailPrice";
import { FaTrashCan } from "react-icons/fa6";
import { Outlet } from "react-router-dom";
    

function CartProducts() {
    const { cart, removeFromCart, changeQuentityInCart } = useGlobalContext()
    return (
        <div className="cartproducts">
            <div className="cartproducts-container">
                <div className="right-cart">
                    <div className="r-c-container">
                        <Outlet/>
                    </div>
                </div>
                <DetailPrice/>
            </div>
        </div>
    )
}

export default CartProducts;